import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import RichText from '../../RichText';
import { EmbeddedEntryNode } from '../../RichText/Nodes';
import { ScrollReveal } from '../../ScrollReveal';

import { TableProps } from '../shared';

export function ShortFormTable({
  title,
  subtitle,
  tableId,
  tableBody
}: TableProps) {
  const RICH_TEXT_OVERRIDES: RenderNode = {
    [BLOCKS.TABLE]: (_node, children) => (
      <div className="sft-table">{children}</div>
    ),
    [BLOCKS.TABLE_ROW]: (_node, children) => (
      <div className="sft-row">{children}</div>
    ),
    [BLOCKS.TABLE_CELL]: (_node, children) => (
      <div className="sft-cell">{children}</div>
    ),
    [BLOCKS.PARAGRAPH]: (_node, children) => (
      <p className="sft-paragraph">{children}</p>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => (
      <div className="mx-0 my-[2.25rem] box-border flex">
        <EmbeddedEntryNode node={node} colour="darkButton">
          {children}
        </EmbeddedEntryNode>
      </div>
    )
  };

  return (
    <ScrollReveal>
      <div
        className="block-container"
        id={tableId!}
        data-blockid="shortFormDisclosureTable"
        data-testid="sft-section"
      >
        <div className="flex w-full justify-center px-3 tablet:px-12">
          <div className="w-full min-w-0 max-w-[1440px] flex-1">
            <div className="-mx-2 flex flex-wrap justify-center pt-8 tablet:-mx-3 tablet:pt-24 desktop:-mx-4">
              <div className="flex justify-center p-2 tablet:p-3 desktop:p-4">
                <div className="flex w-full shrink-0 grow-0 flex-col tablet:w-2/3">
                  {title && (
                    <h2 className="mx-0 my-[2.25rem] text-[1.75rem] font-semibold leading-[2.5rem] desktop:text-[2.625rem] desktop:leading-[3rem]">
                      {title}
                    </h2>
                  )}
                  {subtitle && (
                    <p className="mx-0 mb-[2.25rem] mt-0 text-[1.75rem] font-light leading-[2.5rem] desktop:text-[2.625rem] desktop:leading-[3rem]">
                      {subtitle}
                    </p>
                  )}
                  <RichText
                    data={tableBody}
                    overrideOptions={RICH_TEXT_OVERRIDES}
                    overrideMarkOptions={{
                      [MARKS.CODE]: (children) => {
                        const id = children === '*' ? 'cards' : 'plans';
                        return (
                          <span
                            id={`${tableId}-footnote-${id}`}
                            className="footnote"
                          >
                            {children}
                          </span>
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
